import * as actionTypes from '../actionTypes';

const initialState = {
  allData: [],
  descending: true,
  page: 1,
  rowsPerPage: 10,
  sortBy: 'id',
  total: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_USER_ORDER_REDUCER:
      return {
        ...state,
        allData: action.payload?.data || [],
        descending: action.payload?.pagination?.descending ?? state.descending,
        page: action.payload?.pagination?.page ?? state.page,
        rowsPerPage: action.payload?.pagination?.rowsPerPage ?? state.rowsPerPage,
        sortBy: action.payload?.pagination?.sortBy ?? state.sortBy,
        total: action.payload?.pagination?.total ?? 0,
        status: action.payload?.status ?? false,
      };
    default:
      state = { ...state };
  }
  return state;
};

export default reducer;
